import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import '../scss/global.scss'

Vue.use(Vuetify, { iconfont: 'mdi' })
